<template>
  <b-modal @ok="closePopup" id="intro-popup" centered size="lg" no-close-on-backdrop no-close-on-esc scrollable>
    <template v-slot:modal-header>
      <!-- TODO: put title in json.... -->
      <h2>{{ tourTitle }}</h2>
    </template>
    <div class="row align-items-end">
      <div class="col-12 col-lg-4 text-center instruction-cell">
        <div class="row">
          <div class="col-4 offset-4 col-lg-8 offset-lg-2">
            <img class="img-fluid" src="@/assets/svg/punti_interattivi.svg" />
          </div>
          <div class="col-12 pt-4">
            <p v-html="$t('INTRO_POPUP_HINT_1')"></p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4 text-center instruction-cell">
        <div class="row">
          <div class="col-4 offset-4 col-lg-8 offset-lg-2">
            <img class="img-fluid" src="@/assets/svg/pinch.svg" />
          </div>
          <div class="col-12 pt-4">
            <p v-html="$t('INTRO_POPUP_HINT_2')"></p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4 text-center instruction-cell">
        <div class="row">
          <div class="col-4 offset-4 col-lg-8 offset-lg-2">
            <img class="img-fluid" src="@/assets/svg/trascina.svg" />
          </div>
          <div class="col-12 pt-4">
            <p v-html="$t('INTRO_POPUP_HINT_3')"></p>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer="{ ok }">
      <button class="btn btn-dark py-1 px-4" @click="ok()">
        <span class="px-4">{{ $t('INTRO_POPUP_OK_BUTTON') }}</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['virtualTourData', 'introPopupShown']),
    tourTitle() {
      return (this.virtualTourData && this.virtualTourData.title) || 'Virtual Interactive Showroom'
    }
  },
  mounted() {
    if (!this.introPopupShown) {
      setTimeout(() => {
        this.$bvModal.show('intro-popup')
      }, 500)
    }
  },
  methods: {
    ...mapActions({
      setIntroPopupShown: 'SET_INTRO_POPUP_SHOWN'
    }),
    closePopup() {
      this.$store.dispatch('CHAT_SET_ACTIVE')
      this.setIntroPopupShown(true)
    }
  }
}
</script>

<style lang="scss">
@import '~bootstrap/scss/bootstrap-grid.scss';

#intro-popup___BV_modal_outer_ {
  z-index: 9999 !important;
}

#intro-popup {
  input,
  select {
    border-radius: 0;
    box-shadow: none !important;
    outline: none !important;
    border: 1px solid rgba(#212529, 0.3) !important;

    &.is-invalid {
      border-color: #dc3545 !important;
    }
  }
  .form-check-label {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 18px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .form-check-label input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #fff;
    border: 1px solid rgba(#212529, 0.3);

    &.is-invalid {
      background: rgba(#dc3545, 0.4);
      border-color: #dc3545;
    }
  }

  /* On mouse-over, add a grey background color */
  .form-check-label:hover input ~ .checkmark {
    background-color: rgba(#212529, 0.2);
    &.is-invalid {
      background: rgba(#dc3545, 0.4);
      border-color: #dc3545;
    }
  }

  /* When the checkbox is checked, add a blue background */
  .form-check-label input:checked ~ .checkmark {
    background-color: rgba(#212529, 0.2);
    &.is-invalid {
      background: rgba(#dc3545, 0.4);
      border-color: #dc3545;
    }
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .form-check-label input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .form-check-label .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid rgba(#212529, 1);
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .staff-txt {
    font-size: 12px;
  }
  .privacy-text {
    font-size: 14px;
    @include media-breakpoint-up(lg) {
      font-size: 16px;
    }
    a {
      font-size: 12px;
      @include media-breakpoint-up(lg) {
        font-size: 14px;
      }
      color: #212529;
      text-decoration: underline;
    }
  }
  .modal-header {
    padding-bottom: 0;
    align-items: center;
    justify-content: center;
    border: none;
    h2 {
      text-align: center;
      font-size: 22px;
      @include media-breakpoint-up(lg) {
        font-size: 26px;
        margin-bottom: 15px;
      }
    }
  }
  .modal-content {
    background-color: rgba(255, 255, 255, 0.9);
    font-weight: bolder;
  }
  .modal-footer {
    border: none;
    justify-content: center;
  }
}
</style>
